const sendUserAction = (eventName: string, data: object) => {
  // @ts-ignore (for DD_RUM)
  if (window && window.DD_RUM && window.DD_RUM.addUserAction) {
    // @ts-ignore (for DD_RUM)
    window.DD_RUM.addUserAction(eventName, data);
  }
};

export default sendUserAction;
